import { DateTime } from 'luxon';

type MessageGroupMessage = {
  creatorId?: string | null;
  hasMedia: boolean;
  createdAt: string;
};

const NEW_GROUP_MINUTES_THRESHOLD = 5;

export default function isStartOfMessageGroup(
  currentMessage: MessageGroupMessage,
  prevMessage?: MessageGroupMessage,
) {
  if (prevMessage) {
    const currentDateTime = DateTime.fromISO(currentMessage.createdAt);

    const prevDateTime = DateTime.fromISO(prevMessage.createdAt).plus({
      minutes: NEW_GROUP_MINUTES_THRESHOLD,
    });

    return (
      currentDateTime > prevDateTime ||
      currentMessage.creatorId !== prevMessage.creatorId ||
      currentMessage.hasMedia
    );
  }
  return true;
}
